import * as Yup from 'yup';
import { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// utils
import { fData } from 'src/utils/format-number';
// components
import Iconify from 'src/components/iconify';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, {
    RHFSwitch,
    RHFTextField,
    RHFUploadAvatar,
    RHFAutocomplete,
} from 'src/components/hook-form';
import { Container } from '@mui/material';
import { useSettingsContext } from 'src/components/settings';
import { useAuthContext } from 'src/auth/hooks';
import { getUserDetails, updateUserDetailsApi } from 'src/services/user.service';

// ----------------------------------------------------------------------

export default function Profile({ currentTab }) {
    const { enqueueSnackbar } = useSnackbar();

    const [user, setUser] = useState({});
    // const {user} = useAuthContext();

    const UpdateUserSchema = Yup.object().shape({
        displayName: Yup.string().required('Name is required'),
        email: Yup.string().required('Email is required').email('Email must be a valid email address'),
        phoneNumber: Yup.string().required('Phone number is required'),
        // about: Yup.string().required('About is required'),
    });

    const defaultValues = {
        displayName: '',
        email: '',
        phoneNumber: '',
        // about: '',
    };

    const methods = useForm({
        resolver: yupResolver(UpdateUserSchema),
        defaultValues,
    });

    const {
        setValue,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    const onSubmit = handleSubmit(async (data) => {
        console.log(data)
        try {
            const payload = {
                "mobile_no": data.phoneNumber,
                "name": data.displayName
            }
            const res = await updateUserDetailsApi(payload);
            console.log(res);
            enqueueSnackbar('Update success!');
        } catch (error) {
            console.error(error);
        }
    });

    useEffect(() => {
        const getUserDetailsCaller = async () => {
            try {
                const res = await getUserDetails();
                console.log(res);
                setUser(res.body);
                console.log("user is = ", user);
                setValue("displayName", res.body.name);
                setValue("email", res.body.email);
                setValue("phoneNumber", res.body.mobile_no);
            } catch (error) {
                console.log(error)
            }
        }
        getUserDetailsCaller();
    }, [currentTab]);

    return (
        <FormProvider methods={methods} onSubmit={onSubmit}>
            <Card sx={{ p: 3 }}>
                <Box
                    rowGap={3}
                    // columnGap={2}

                    // gridTemplateColumns={{
                    //     xs: 'repeat(1, 1fr)',
                    //     sm: 'repeat(2, 1fr)',
                    // }}
                    sx={{ display: "flex", flexDirection: "column" }}
                >
                    <Stack>
                        <Typography variant="h6">Name</Typography>
                        <RHFTextField name="displayName" />
                    </Stack>
                    <Stack>
                        <Typography variant="h6">Email</Typography>
                        <RHFTextField
                            name="email"
                            disabled={true}
                        />
                    </Stack>
                    <Stack>
                        <Typography variant="h6">Phone Number</Typography>
                        <RHFTextField name="phoneNumber" />
                    </Stack>

                </Box>

                <Stack spacing={3} alignItems="flex-end" sx={{ mt: 3 }}>
                    {/* <RHFTextField name="about" multiline rows={4} label="About" /> */}

                    <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                        Save Changes
                    </LoadingButton>
                </Stack>
            </Card>
        </FormProvider>
    );
}
